export { default as minioService } from './minio-service'
